import React from "react";
import "../css/AboutUs.css";

const AboutUs = () => {
  return (
    <div className="about-page">
      {}
      <div className="about-hero">
        <div className="about-hero-text">
          <h1>About Sahara Public School</h1>
          <p>Nurturing Excellence in the heart of Kapilvastu</p>
        </div>
      </div>

      {}
      <section className="geo-context-section">
        <div className="about-container grid-2">
          <div className="geo-text">
            <span className="sub-tag">OUR LOCATION</span>
            <h2>International Excellence in Kapilvastu</h2>
            <p>
              We are an international English medium school in Kapilvastu –
              Nepal. Nepal is a mountainous country where 83% of the area
              consists of mountains and hills. The remaining 17% is occupied by
              the flat land of the Terai, where our school brings world-class
              education to the local community.
            </p>
            <p>
              Situated between the high Himalayas and the river basins, our
              school provides a diverse and serene environment for learning,
              bridging the gap between local tradition and global standards.
            </p>
          </div>
          <div className="geo-image">
            <img src="/images/high.jpg" alt="Nepal Landscape" />
          </div>
        </div>
      </section>

      {}
      <section className="about-content-section bg-light">
        <div className="about-container">
          <div className="intro-text">
            <h2>Welcome to a Legacy of Excellence</h2>
            <p>
              Sahara Public Secondary School is dedicated to providing a
              holistic education that prepares students for a rapidly changing
              world. We blend academic rigor with creative innovation and strong
              moral values. Nepal has the latitude difference of about 4 degrees
              and the average north south width is 193 kilo meter. We can hardly
              find such diversity in altitude elsewhere in the world within
              these small variations. The country has thousands of rivers
              flowing from north to south forming gorges, river basins and
              valleys. On the basis of altitude, the country can broadly be
              divided into the Himalayan, Hill and terai region. It is a
              land-locked country and has no outlet to the sea. China lies in
              the north and India lies to the west, south and east.
            </p>
          </div>

          <div className="vision-mission-grid">
            <div className="vm-card">
              <div className="vm-icon">🎯</div>
              <h3>Our Mission</h3>
              <p>
                Provide quality; educational programs that integrate academic,
                and Nepali studies. Promote excellent personal manners, high
                moral values, and strong leadership skills. Prepare students to
                become good citizens and contributing members of society.
                Empower students to seek and succeed in post-secondary
                education. Guide students to develop life skills and interests.
              </p>
            </div>
            <div className="vm-card">
              <div className="vm-icon">👁️‍🗨️</div>
              <h3>Our Vision</h3>
              <p>
                Sahara Public School upholds the tradition of great respect for
                knowledge and an open spirit of inquiry. The rich vein of
                excellence in learning within the heritage is the foundation of
                the rigorous academic program which is intended to serve the
                needs of the modern world without sacrificing moral and
                spiritual values. Since the faith addresses the complete
                personality, it is School’s philosophy that knowledge of the
                world and practice of our shared beliefs should be integrated
                into a cohesive whole.
              </p>
            </div>
          </div>
        </div>
      </section>

      {}
      <section className="principal-message-section">
        <div className="about-container p-msg-wrapper">
          <div className="p-image">
            <img src="/images/principal.jpg" alt="Principal" />
            <div className="p-badge">Principal</div>
          </div>
          <div className="p-text">
            <h2>Message From the Principal</h2>
            <p className="quote">
              "Dear Friends, Of all the prerequisites of development, human
              resource is the most important one. Human resource can be prepared
              through education. Education uplifts the level of knowledge. It
              helps all round development of human beings. For instance,
              education teaches us skill and good behaviour. Hence, it enables
              us to live a quality and accomplished life. Furthermore, it cannot
              be stolen by thieves and confiscated by the government. The more
              we give it to other the more it increases. For this reason,
              education has been regarded as the greatest wealth.Global Indian
              International School A large number of students in the world,
              whose parents are unable to pay schooling fees, while they have
              ambitions to pursue their studies and struggle to find support
              from any side, but failed. Their parents struggle to make bright
              future of their children, but they are failed to fulfill basic
              necessities of their house. So, it raises the question that how
              they will bear the fees of their children? And thus their children
              cannot continue their studies. In the context of Nepal most
              students cannot continue their studies due to poverty. Nepal is
              known as one of the poorest country in the world, where a large
              number of people are living under the poverty line. The conditions
              of the Muslims of Nepal are not so miserable and their identity is
              under the threat. They are backward socially, educational,
              economically, culturally and politically. Illiteracy and poverty
              and ignorance are the main factor of their backwardness.
              Illiteracy and poverty are linked with each other. If illiteracy
              is removed, the poverty will be automatically removed. Keeping
              this concern in mind and on the requests & desires of Islamic
              Movement’s activists in Nepal, for development & improvement of
              educational standard in Muslim Community, Sahara Public School has
              been established at Krishna Nagar, District of Kapilvastu, State
              No.: 05, Nepal. "
            </p>
            <h4>- Mr. Ghufran Ahmad Shakir, Principal</h4>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
